// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"427e0402","94":"828f48cf","130":"d22ac7e1","150":"4ae31eae","234":"e29147af","466":"0b3bb9c4","672":"6b472b0c","802":"75bb5bba","814":"a087d635"}[chunkId] + ".chunk.js";
};